module.exports = "/_next/static/images/instrument_4-9ef48c7e041dfa6bbade60f9e49cb29c.png";